// Scan-link status vocabulary, previously duplicated verbatim in GenerateScanLink and
// ScanLinksTable.
//
// Worth knowing while reading this: the backend only ever writes 'created' or
// 'revoked'. 'unused', 'opened' and 'used' are mapped by the frontend but nothing
// sets them, so they are kept for compatibility with existing rows rather than
// because the app can produce them.
export const SCAN_LINK_STATUS = {
  created: { label: "Created", tone: "ok" },
  unused:  { label: "Unused",  tone: "idle" },
  opened:  { label: "Opened",  tone: "ok" },
  used:    { label: "Used",    tone: "ok" },
  revoked: { label: "Revoked", tone: "danger" },
};

export const statusFor = (s) => SCAN_LINK_STATUS[s] || { label: s || "Unknown", tone: "idle" };
